module.exports = __webpack_public_path__ + "static/media/moraine-28.520548d5.jpg";